export default __webpack_public_path__ + "static/media/Logo_Keolis_Bordeaux.8eb12df4.jpg";